/**
 * AdminAgentsRpcClient - AtomRpc integration for the unified admin Agents
 * endpoints (`admin/agents/*`): `create` (increments the customer's
 * subscription at the standing per-agent rate, no checkout),
 * `mintInstallLink` (Mac curl one-liner or cloud progress handle),
 * `lifecycle` (stop/start/deprovision with legal-transition enforcement),
 * and `fleetList`.
 *
 * Backs the collapsed Agents fleet page: `fleetList` returns ONE
 * server-merged row per agent (account fields + node health + rate). The
 * agent detail page's Overview tab drives `lifecycle` through this client.
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminAgentsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminAgentsRpcClient extends AtomRpc.Tag<AdminAgentsRpcClient>()(
  "AdminAgentsRpcClient",
  {
    group: AdminAgentsRpcs,
    protocol: makeRpcClientLayer(AdminAgentsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
